import { render, staticRenderFns } from "./WMACallIcon.vue?vue&type=template&id=cbbfc922&"
import script from "./WMACallIcon.vue?vue&type=script&lang=js&"
export * from "./WMACallIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports